import React from 'react';
import BlockHeightWidget from '../blockchain/BlockHeightWidget';
import SupplyWidget from './supply/SupplyWidget';
import DistributionWidget from './distribution/DistributionWidget';
import TransactionActivityWidget from './transactions/TransactionActivityWidget';
// import { useNetworkSummary } from '../../hooks/network/useNetworkSummary'; // OLD IMPORT
import { useNetwork } from '../../contexts/NetworkContext'; // NEW IMPORT
import { useMasternodes } from '../../hooks/useMasternodes';

export default function NetworkStats() {
  // const { data, loading } = useNetworkSummary(); // OLD USAGE
  const { data, loading: networkLoading, error } = useNetwork(); // NEW USAGE
  const { nodes, loading: masternodesLoading } = useMasternodes();

  const loading = networkLoading || masternodesLoading;

  if (loading) {
    return (
      <div className="grid grid-cols-1 gap-4">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="bg-slate-800/50 rounded-xl p-4 md:p-6 border border-green-500/10 animate-pulse">
            <div className="h-20"></div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    // Optional: Display a more prominent error message for the whole section
    return <div className="text-red-400 p-4">Error loading network statistics: {error.message}</div>;
  }

  // Calculate total masternode supply - all collateral is locked regardless of node status
  const masternodeSupply = nodes.reduce((sum, node) => sum + (node.tier || 0), 0);
  const circulatingSupply = (data.supply ?? 0) - masternodeSupply;

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      <div className="md:col-span-2">
        <BlockHeightWidget />
      </div>
      <div className="md:col-span-2">
        <SupplyWidget
          supply={data.supply ?? 0} // Pass down with nullish coalescing for safety
          masternodes={masternodeSupply}
          circulating={circulatingSupply}
        />
      </div>
      <div className="md:col-span-2">
        <DistributionWidget />
      </div>
      <div className="md:col-span-2">
        <TransactionActivityWidget />
      </div>
    </div>
  );
}